import React, { useState, useEffect, useMemo, useRef } from "react";
import CustomCalendar from "./CustomCalendar";
import AddSessionForm from "./components/AddSessionForm";
import AddCalendarEventForm from "./components/AddCalendarEventForm";
import TotalWorkingDaysReport from "./components/TotalWorkingDaysReport";
import PrintableAcademicCalendar from "./components/PrintableAcademicCalendar";
import SessionList from "./components/SessionList";
import GenericEventList from "./components/GenericEventList";
import CheckboxEventList from "./components/CheckboxEventList";
import HolidayCategoryTabs from "./components/HolidayCategoryTabs";
import masterData from "./components/masterData";
import CompetitionCategoryTabs from "./components/CompetitionCategoryTabs";
import CelebrationsCalendar from "./components/CelebrationsCalendar";
import AwarenessDaysCalendar from "./components/AwarenessDaysCalendar";
import userStore from "../../zustand/userStore";
import { useDispatch, useSelector } from "react-redux";
import MobileNavbar from "./MobileNavbar";
import DemoContentButton from "../../components/DemoContentButton";
import {
  loadCalendarItemsFromLocalStorage,
  fetchHolidaysThunk,
  deleteHolidayThunk,
  fetchSessionsThunk,
  deleteSessionThunk,
  deleteEventThunk,
  fetchCompetitionsThunk,
  deleteCompetitionThunk,
  fetchExamsThunk,
  deleteExamThunk,
  fetchPtmsThunk,
  deletePtmThunk,
  createCompetitionThunk,
  createExamThunk,
  postHolidayThunk,
  // Import the new reducers for direct state updates
  addHolidayToState,
  addCompetitionToState,
  addExamToState,
  fetchProposedHolidaysThunk,
  fetchProposedCompetitionsThunk,
  fetchCelebrationsThunk,
  deleteCelebrationThunk, // Added fetch for celebrations
  fetchAwarenessThunk,
  fetchHolidayCategoriesThunk,
  fetchProposedCelebrationsThunk,
  fetchProposedAwarenessThunk, // Added fetch for awareness days
} from "./redux/academicCalendarSlice";
import moment from "moment";
import { useNavigate, useLocation, Link } from "react-router-dom";
import ExamCategoryTabs from "./components/ExamCategoryTabs";
import { getMasterDataByUserId } from "../../pages/masterData/redux/masterDataThunk";
import { logout } from "../../auth/authSlice";
import "../../App.css";
import "./academic-calendar-responsive.css";
import { setPendingNavigation, setStepIndex, startTour } from "../../redux/globalJoyrideSlice";
import {
  getAcademicCalendarTourSteps,
  getAwarenessTourSteps,
  getCalendarSteps,
  getCompetitionTourSteps,
  getExamTourSteps,
  getHolidayTourSteps,
  getPtmTourSteps
} from "../../tour/academicCalenderTourSteps";

const AcademicCalendar = () => {
  const userData = userStore((state) => state.user);
  const { pathname } = useLocation();
  console.log(userData);
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const logOut = () => {
    dispatch(logout());
    navigate("/home");
  };

  const holidays = useSelector((state) => state.academicCalendar.holidays);
  const sessions = useSelector((state) => state.academicCalendar.sessions);
  const events = useSelector((state) => state.academicCalendar.events);
  const competitions = useSelector(
    (state) => state.academicCalendar.competitions
  );
  const exams = useSelector((state) => state.academicCalendar.exams);
  const ptms = useSelector((state) => state.academicCalendar.ptms);
  const celebrations = useSelector(
    (state) => state.academicCalendar.celebrations
  ); // Get celebrations from store
  const awarenessDays = useSelector(
    (state) => state.academicCalendar.awarenessDays
  ); // Get awareness days from store
  const academicCalendarData = useSelector(
    (state) => state.academicCalendar.academicData
  );

  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem("activeTab") || "calendar";
  });

  const [celebrationSubTab, setCelebrationSubTab] = useState("select");
  const [showAddCelebrationForm, setShowAddCelebrationForm] = useState(false);
  const [editCelebration, setEditCelebration] = useState(null);
  const [subTab, setSubTab] = useState(null);

  const [awarenessSubTab, setAwarenessSubTab] = useState("select");
  const [showAddAwarenessForm, setShowAddAwarenessForm] = useState(false);
  const [editAwareness, setEditAwareness] = useState(null);

  const [showAddSessionForm, setShowAddSessionForm] = useState(false);
  const [showAddEventForm, setShowAddEventForm] = useState(false);
  const [showAddHolidayForm, setShowAddHolidayForm] = useState(false);
  const [showAddCompetitionForm, setShowAddCompetitionForm] = useState(false);
  const [showAddExamForm, setShowAddExamForm] = useState(false);
  const [showAddPtmForm, setShowAddPtmForm] = useState(false);

  const [editHoliday, setEditHoliday] = useState(null);
  const [editSession, setEditSession] = useState(null);
  const [editEvent, setEditEvent] = useState(null);
  const [editCompetition, setEditCompetition] = useState(null);
  const [editExam, setEditExam] = useState(null);
  const [editPtm, setEditPtm] = useState(null);
  const [tourStage, setTourStage] = useState("sessions");
  const [holidaySubTab, setHolidaySubTab] = useState(() => {
    const storedTab = localStorage.getItem("activeTab");
    return storedTab === "holidays" ? "select" : "checkboxList";
  });

  const [competitionSubTab, setCompetitionSubTab] = useState("checkboxList");
  const [selectedCompetitions, setSelectedCompetitions] = useState([]);
  const [examSubTab, setExamSubTab] = useState("checkboxList");
  const [recentHolidayId, setRecentHolidayId] = useState(null);
  const [recentCompetitionId, setRecentCompetitionId] = useState(null);
  const [recentExamId, setRecentExamId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const pendingNavigation = useSelector(
    (state) => state.globalJoyride.pendingNavigation
  );

  useEffect(() => {
    if (!pendingNavigation) return;

    setActiveTab(pendingNavigation.tab);

    if (pendingNavigation.subTab) {
      if (pendingNavigation.tab === "awareness") {
        setAwarenessSubTab(pendingNavigation.subTab);
      }

      if (pendingNavigation.tab === "holidays") {
        setHolidaySubTab(pendingNavigation.subTab);
      }


      if (pendingNavigation.tab === "competitions") {
        setCompetitionSubTab(pendingNavigation.subTab);
      }

      if (pendingNavigation.tab === "exams") {
        setExamSubTab(pendingNavigation.subTab);
      }
    }

    dispatch(setPendingNavigation(null));
  }, [pendingNavigation]);

  useEffect(() => {

    setActiveTab("sessions");
    localStorage.setItem("activeTab", "sessions");
    requestAnimationFrame(() => {
      dispatch(
        startTour({
          tourName: "academic-sessions",
          steps: getAcademicCalendarTourSteps(),
        })
      );
      dispatch(setStepIndex(0));
    });
  }, []);

  useEffect(() => {
    if (activeTab !== "awareness") return;

    setTimeout(() => {
      dispatch(
        startTour({
          tourName: "awareness",
          steps: getAwarenessTourSteps({
            dispatch,
            setTourStage,
            setActiveTab,
            setHolidaySubTab,
            setAwarenessSubTab: setSubTab,
            setShowAddAwarenessForm: setShowForm,
          }),
        })
      );

      dispatch(setStepIndex(0));
    }, 0);
  }, [activeTab]);

  useEffect(() => {
    if (activeTab !== "holidays") return;

    setTimeout(() => {
      dispatch(
        startTour({
          tourName: "holidays",
          steps: getHolidayTourSteps({
            dispatch,
            setTourStage,
            setActiveTab,
            setShowAddHolidayForm,
            setHolidaySubTab,
            setCompetitionSubTab,
          }),
        })
      );

      dispatch(setStepIndex(0));
    }, 0);
  }, [activeTab]);

  useEffect(() => {
    if (activeTab !== "competitions") return;

    setTimeout(() => {
      dispatch(
        startTour({
          tourName: "competitions",
          steps: getCompetitionTourSteps({
            dispatch,
            setShowAddCompetitionForm,
            setCompetitionSubTab,
            setTourStage,
            setActiveTab,
            setExamSubTab,
          }),
        })
      );

      dispatch(setStepIndex(0));
    }, 0);
  }, [activeTab]);

  useEffect(() => {
    if (activeTab !== "exams") return;


    setTimeout(() => {
      dispatch(
        startTour({
          tourName: "exams",
          steps: getExamTourSteps({
            dispatch,
            setExamSubTab,
            setShowAddExamForm,
            setTourStage,
            setActiveTab,
          }),
        })
      );

      dispatch(setStepIndex(0));
    }, 0);
  }, [activeTab]);


  useEffect(() => {
    if (activeTab !== "ptms") return;

    const btn = document.querySelector('[data-tour="ptm-add-btn"]');
    if (!btn) return;

    // 🔥 THIS is what Next path was missing
    setTimeout(() => {
      dispatch(
        startTour({
          tourName: "ptms",
          steps: getPtmTourSteps(),
        })
      );
      dispatch(setStepIndex(0)); // first PTM step
    }, 0);
  }, [activeTab]);

  useEffect(() => {
    if (activeTab !== "calendar") return;

    const waitForCalendar = () => {
      const el = document.querySelector('[data-tour="view-calendar"]');

      // ✅ Small delay to ensure previous tour is fully stopped
      setTimeout(() => {
        dispatch(
          startTour({
            tourName: "calendar",
            steps: getCalendarSteps(),
            run: true,
          })
        );
        dispatch(setStepIndex(0));
      }, 100);
    };

    waitForCalendar();
  }, [activeTab, dispatch]);
  // State to hold session information from CustomCalendar
  const [sessionInfo, setSessionInfo] = useState({
    sessionStart: "N/A",
    sessionEnd: "N/A",
    workingDays: "N/A",
  });

  const { exams: masterExams } = masterData;
  const masterHolidays = useSelector(
    (state) => state.academicCalendar.masterHolidays
  );
  const masterCompetitions = useSelector(
    (state) => state.academicCalendar.masterCompetitions
  );

  useEffect(() => {
    dispatch(getMasterDataByUserId(userData.id));
  }, []);

  useEffect(() => {
    if (activeTab === "holidays" && holidaySubTab === "select") {
      console.log("Calling Proposed Holidays API with user_id", userData.id);
      dispatch(fetchProposedHolidaysThunk({ school_id: 1 }));
    }
  }, [activeTab, holidaySubTab, dispatch]);
  // useEffect(() => {
  //   if (activeTab === "competitions" && competitionSubTab === "checkboxList") {
  //     dispatch(fetchProposedCompetitionsThunk());
  //   }
  // }, [competitionSubTab, dispatch]);

  useEffect(() => {
    if (activeTab === "competitions" && competitionSubTab === "checkboxList") {
      dispatch(fetchProposedCompetitionsThunk({ user_id: userData.id }));
    }
  }, [activeTab, competitionSubTab, dispatch, userData.id]);


  useEffect(() => {
    if (examSubTab === "checkboxList") {
      dispatch(fetchHolidayCategoriesThunk());
    }
  }, [examSubTab, dispatch]);



  // Fetch all calendar data on component mount
  useEffect(() => {
    dispatch(loadCalendarItemsFromLocalStorage());
    dispatch(fetchHolidaysThunk({ user_id: userData.id }));
    dispatch(fetchSessionsThunk());
    dispatch(fetchCompetitionsThunk({ user_id: userData.id }));
    dispatch(fetchExamsThunk({ user_id: userData.id }));
    dispatch(fetchPtmsThunk({ user_id: userData.id }));
    dispatch(fetchCelebrationsThunk({ user_id: userData.id })); // Fetch celebrations
    dispatch(fetchAwarenessThunk({ user_id: userData.id })); // Fetch awareness days
  }, [dispatch]);

  const groupedHolidays = Array.isArray(masterHolidays)
    ? masterHolidays.reduce((acc, holiday) => {
      const category = holiday.category_name || "Uncategorized";
      const holidayWithName = {
        ...holiday,
        name: holiday.details,
      };
      if (!acc[category]) acc[category] = [];
      acc[category].push(holidayWithName);
      return acc;
    }, {})
    : {};

  // const groupedCompetitions = masterCompetitions?.reduce((acc, comp) => {
  //   const category = comp.competition_name?.trim() || "Uncategorized";

  //   const competitionWithName = {
  //     ...comp,
  //     name: comp.details,
  //   };

  //   if (!acc[category]) {
  //     acc[category] = [];
  //   }

  //   acc[category].push(competitionWithName);
  //   return acc;
  // }, {});
  const groupedCompetitions = Array.isArray(masterCompetitions)
    ? masterCompetitions.reduce((acc, comp) => {
      const category = comp.competition_name?.trim() || "Uncategorized";

      const competitionWithName = {
        ...comp,
        name: comp.details,
      };

      if (!acc[category]) acc[category] = [];
      acc[category].push(competitionWithName);

      return acc;
    }, {})
    : {};


  const handleEditHoliday = (holiday) => {
    setEditHoliday({
      ...holiday,
      start_date: moment(holiday.start_date).format("YYYY-MM-DD"),
      end_date: moment(holiday.end_date).format("YYYY-MM-DD"),
    });
    setShowAddHolidayForm(true);
    setHolidaySubTab("custom");
  };

  const handleDeleteHoliday = (id) => {
    if (window.confirm("Are you sure you want to delete this holiday?")) {
      dispatch(deleteHolidayThunk(id));
    }
  };
  const handleEditCelebration = (celebration) => {
    setEditCelebration(celebration);
    setShowAddCelebrationForm(true);
  };

  const handleDeleteCelebration = (id) => {
    if (window.confirm("Are you sure you want to delete this celebration?")) {
      dispatch(deleteCelebrationThunk(id));
    }
  };

  const handleEditSession = (session) => {
    setEditSession(session);
    setShowAddSessionForm(true);
  };

  const handleDeleteSession = (id) => {
    if (window.confirm("Are you sure you want to delete this session?")) {
      dispatch(deleteSessionThunk(id));
    }
  };

  const handleEditEvent = (event) => {
    setEditEvent(event);
    setShowAddEventForm(true);
  };

  const handleDeleteEvent = (id) => {
    if (window.confirm("Are you sure you want to delete this event?")) {
      dispatch(deleteEventThunk(id));
    }
  };

  const handleEditCompetition = (competition) => {
    setEditCompetition(competition);
    setShowAddCompetitionForm(true);
    setCompetitionSubTab("addForm"); // Switch to add form when editing
  };

  const handleDeleteCompetition = (id) => {
    if (window.confirm("Are you sure you want to delete this competition?")) {
      dispatch(deleteCompetitionThunk(id));
    }
  };
  const handleEditExam = (exam) => {
    // Normalize category ID for AddCalendarEventForm
    const normalizedExam = {
      ...exam,
      category_id: exam.category_id || exam.exam_cat_id || "",
    };

    setEditExam(normalizedExam);
    setShowAddExamForm(true);
    setExamSubTab("addForm"); // Switch to add form when editing
  };

  const handleDeleteExam = (id) => {
    if (
      window.confirm(
        "Are you sure you want to delete to delete this examination/test?"
      )
    ) {
      dispatch(deleteExamThunk(id));
    }
  };

  const handleEditPtm = (ptm) => {
    setEditPtm(ptm);
    setShowAddPtmForm(true);
  };

  const handleDeletePtm = (id) => {
    if (window.confirm("Are you sure you want to delete this PTM?")) {
      dispatch(deletePtmThunk(id));
    }
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    localStorage.setItem("activeTab", tabName);
    setShowAddSessionForm(false);
    setShowAddEventForm(false);
    setShowAddHolidayForm(false);
    setShowAddCompetitionForm(false);
    setShowAddExamForm(false);
    setShowAddPtmForm(false);
    setShowAddCelebrationForm(false);
    setShowAddAwarenessForm(false);
    setEditHoliday(null);
    setEditSession(null);
    setEditEvent(null);
    setEditCompetition(null);
    setEditExam(null);
    setEditPtm(null);
    setEditCelebration(null);
    setEditAwareness(null);

    // Reset sub-tabs to "checkboxList" when main tab changes for relevant tabs
    if (tabName === "holidays") {
      setHolidaySubTab("select");
    } else if (tabName === "competitions") {
      setCompetitionSubTab("checkboxList");
    } else if (tabName === "exams") {
      // setExamSubTab("checkboxList");
      if (userData?.roles !== "user") {
        setExamSubTab("checkboxList");
      } else {
        setExamSubTab("fullList");
      }
    } else if (tabName === "celebrations") {
      setCelebrationSubTab("select");
    } else if (tabName === "awareness") {
      setAwarenessSubTab("select");
    } else {
      // For other tabs, ensure sub-tabs are reset to their default or a logical view
      setHolidaySubTab("fullList"); // Example: if coming from another tab, show full list
      setCompetitionSubTab("fullList");
      setExamSubTab("fullList");
      setCelebrationSubTab("list");
      setAwarenessSubTab("list");
    }

    if (tabName === "holidays") {
      dispatch(fetchHolidaysThunk());
    } else if (tabName === "sessions") {
      dispatch(fetchSessionsThunk());
    } else if (tabName === "competitions") {
      dispatch(fetchCompetitionsThunk({ user_id: userData.id }));
      dispatch(fetchProposedCompetitionsThunk({ user_id: userData.id }));
      //dispatch(fetchProposedCompetitionsThunk({ user_id: userData.id }));
    } else if (tabName === "exams") {
      dispatch(fetchExamsThunk());
    } else if (tabName === "ptms") {
      dispatch(fetchPtmsThunk());
    } else if (tabName === "celebrations") {
      dispatch(fetchCelebrationsThunk({ user_id: userData.id }));
      dispatch(fetchProposedCelebrationsThunk({ user_id: userData.id }));
    } else if (tabName === "awareness") {
      dispatch(fetchAwarenessThunk({ user_id: userData.id }));
      dispatch(fetchProposedAwarenessThunk({ user_id: userData.id }));
    }
  };

  // Handler for when a checkbox item is selected
  const handleSelectAndNavigateToList = (itemType, item, isChecked) => {
    console.log(
      `Checkbox ${isChecked ? "checked" : "unchecked"} for ${itemType}:`,
      item
    );

    if (isChecked) {
      // Create a new item in the backend
      const payload = {
        school_id: 101, // Replace with actual school ID
        user_id: 5, // Replace with actual user ID
        details: item.name,
        start_date: item.start_date,
        end_date: item.end_date,
        status: "active",
      };

      switch (itemType) {
        case "holiday":
          dispatch(postHolidayThunk(payload));
          break;
        case "competition":
          dispatch(createCompetitionThunk(payload));
          break;
        case "exam":
          dispatch(createExamThunk(payload));
          break;
        default:
          console.warn(`Unknown item type: ${itemType}`);
      }
    } else {
      // Find and delete the item from the backend
      let itemToDelete = null;

      switch (itemType) {
        case "holiday":
          itemToDelete = holidays.find(
            (activeItem) =>
              activeItem.details === item.name &&
              activeItem.start_date === item.start_date &&
              activeItem.end_date === item.end_date
          );
          if (itemToDelete) dispatch(deleteHolidayThunk(itemToDelete.id));
          break;
        case "competition":
          itemToDelete = competitions.find(
            (activeItem) =>
              activeItem.details === item.name &&
              activeItem.start_date === item.start_date &&
              activeItem.end_date === item.end_date
          );
          if (itemToDelete) dispatch(deleteCompetitionThunk(itemToDelete.id));
          break;
        case "exam":
          itemToDelete = exams.find(
            (activeItem) =>
              activeItem.details === item.name &&
              activeItem.start_date === item.start_date &&
              activeItem.end_date === item.end_date
          );
          if (itemToDelete) dispatch(deleteExamThunk(itemToDelete.id));
          break;
        default:
          console.warn(`Unknown item type: ${itemType}`);
      }
    }

    // Navigate to the full list tab after selection
    if (isChecked) {
      switch (itemType) {
        case "holiday":
          setHolidaySubTab("fullList");
          break;
        case "competition":
          setCompetitionSubTab("fullList");
          break;
        case "exam":
          setExamSubTab("fullList");
          break;
        default:
          break;
      }
    }
  };

  // Filter upcoming events for the "Upcoming Events" section
  const upcomingEvents = useMemo(() => {
    const now = moment();
    return academicCalendarData
      .filter((item) =>
        moment(item.date || item.start_date, "DD-MM-YYYY").isSameOrAfter(
          now,
          "day"
        )
      )
      .sort((a, b) =>
        moment(a.date || a.start_date, "DD-MM-YYYY").diff(
          moment(b.date || b.start_date, "DD-MM-YYYY")
        )
      )
      .slice(0, 5); // Show top 5 upcoming events
  }, [academicCalendarData]);

  const renderContent = () => {
    switch (activeTab) {
      case "calendar":
        return (
          <div data-tour="view-calendar">
            <CustomCalendar
              initialView="month"
              onSessionInfoUpdate={setSessionInfo}
            />
          </div>
        );
      case "sessions":
        return (
          <div className=" mx-5 px-5">
            {showAddSessionForm ? (
              <AddSessionForm
                onClose={({ goToCelebrations }) => {
                  setShowAddSessionForm(false);
                  setEditSession(null);

                  if (goToCelebrations) {
                    localStorage.setItem("startCelebrationTour", "true");
                    handleTabClick("celebrations");
                  }
                }}
                editItem={editSession}
                existingSessions={sessions}
                setActiveTab={setActiveTab}
                setTourStage={setTourStage}
                setCelebrationSubTab={setCelebrationSubTab}
                setShowAddCelebrationForm={setShowAddCelebrationForm}
                setAwarenessSubTab={setAwarenessSubTab}
              />
            ) : (
              <>
                <div className="d-flex justify-content-between align-items-center ">
                  {/* <h3 className=" ">Academic Sessions</h3> */}
                  <div className="mb-3">
                    <button
                      className="btn btn-primary me-2 mb-0"
                      onClick={() => handleTabClick("calendar")}
                    >
                      Back
                    </button>
                    {userData.roles !== "user" && (
                      <button
                        className="btn btn-primary mb-0"
                        data-tour="add-session"
                        onClick={() => {
                          setShowAddSessionForm(true);
                          dispatch(setStepIndex(1));
                        }}
                      >
                        Add Session
                      </button>
                    )}
                  </div>
                </div>
                <SessionList
                  sessions={sessions}
                  onEdit={handleEditSession}
                  onDelete={handleDeleteSession}
                  userData={userData}
                />
              </>
            )}
          </div>
        );
      case "events": // This case is now effectively handled by "Celebrations" and "Awareness Days"
        return (
          <div className="mx-5 px-5">
            {showAddEventForm ? (
              <AddCalendarEventForm
                onClose={() => {
                  setShowAddEventForm(false);
                  setEditEvent(null);
                }}
                itemType="event"
                editItem={editEvent}
              />
            ) : (
              <>
                <div className="d-flex justify-content-end mb-3">
                  <button
                    className="btn btn-primary"
                    onClick={() => setShowAddEventForm(true)}
                  >
                    Add Event
                  </button>
                </div>
                <GenericEventList
                  itemType="event"
                  title="Event / Celebration"
                  data={events}
                  onEdit={handleEditEvent}
                  onDelete={handleDeleteEvent}
                />
              </>
            )}
          </div>
        );
      case "celebrations":
        return (
          <CelebrationsCalendar
            onEdit={handleEditCelebration}
            onDelete={handleDeleteCelebration}
            onBackToCalendar={() => handleTabClick("calendar")}
            onClose={({ goToAwareness }) => {     // ✅ SAME PATTERN
              if (goToAwareness) {
                localStorage.setItem("startAwarenessTour", "true");
                handleTabClick("awareness");
              }
            }}
            setActiveTab={setActiveTab}
            setTourStage={setTourStage}
            setAwarenessSubTab={setAwarenessSubTab}
          />
        );
      case "awareness":
        return (
          <AwarenessDaysCalendar
            onBackToCalendar={() => handleTabClick("calendar")}
            onClose={({ goToHolidays }) => {
              if (goToHolidays) {
                // 🔥 FORCE navigation
                setTourStage("holidays");
                setActiveTab("holidays");

                // 🔥 Delay to avoid React state overwrite
                setTimeout(() => {
                  setHolidaySubTab("select"); // PROPOSED LIST
                }, 0);

                //localStorage.setItem("startHolidayTour", "true");
              }
            }}
            setActiveTab={setActiveTab}
            setTourStage={setTourStage}
            setHolidaySubTab={setHolidaySubTab}
            setAwarenessSubTab={setAwarenessSubTab}
            setShowAddAwarenessForm={setShowAddAwarenessForm}
          />
        );
      case "holidays":
        return (
          <div className="mx-5 px-5">
            {/* Updated sub-tab navigation */}
            <div className="d-flex mb-3">
              <button
                className={`btn me-2 ${holidaySubTab === "select" ? "btn-primary" : "btn-light"
                  }`}
                data-tour="holidays-proposed-tab"
                onClick={() => {
                  setHolidaySubTab("select");
                  setShowAddHolidayForm(false);
                  setEditHoliday(null);

                  dispatch(setStepIndex(1));
                }}
              >
                Proposed List
              </button>
              <button
                className={`btn me-2 ${holidaySubTab === "list" ? "btn-primary" : "btn-light"
                  }`}
                onClick={() => {
                  setHolidaySubTab("list");
                  setShowAddHolidayForm(false);
                  setEditHoliday(null);
                }}
                data-tour="holidays-list"
              >
                View Holidays
              </button>
              {/* {userData.roles !== "user" && ( */}
              <button
                className={`btn ${holidaySubTab === "custom" ? "btn-primary" : "btn-light"
                  }`}
                onClick={() => {
                  setHolidaySubTab("custom");
                  setShowAddHolidayForm(true);
                  setEditHoliday(null);
                }}
              >
                Add Custom Holiday
              </button>
              {/* )} */}
              <button
                className="btn btn-primary ms-auto"
                onClick={() => handleTabClick("calendar")}
              >
                Back
              </button>
            </div>
            {holidaySubTab === "select" && groupedHolidays && (
              <div data-tour="holiday-checkbox-list">
                <HolidayCategoryTabs
                  categories={groupedHolidays} // ✅ Pass the actual grouped holidays here
                  submittedHolidays={holidays}
                  onAllCompleted={() => {
                    // 1️⃣ Move tour flow
                    setTourStage("competitions");

                    // 2️⃣ Switch tab
                    setActiveTab("competitions");

                    // 3️⃣ Open proposed competitions
                    setCompetitionSubTab("checkboxList");
                  }}
                  onSelect={(holiday) => {
                    setEditHoliday({
                      ...holiday,
                      start_date: moment(holiday.start_date).format("YYYY-MM-DD"),
                      end_date: moment(holiday.end_date).format("YYYY-MM-DD"),
                    });
                    setShowAddHolidayForm(true);
                    setHolidaySubTab("custom");
                  }}
                  onBulkSubmit={async (selectedData) => {
                    try {
                      let lastInsertedId = null;

                      for (const holiday of selectedData) {
                        const payload = {
                          school_id: 1,
                          user_id: userData.id,
                          details: holiday.name,
                          start_date: moment(holiday.start_date).format(
                            "YYYY-MM-DD"
                          ),
                          end_date: moment(holiday.end_date).format("YYYY-MM-DD"),
                          status: "active",
                          category_id: holiday.category_id || 3,
                        };
                        const res = await dispatch(postHolidayThunk(payload)).unwrap();
                        lastInsertedId = res?.id;
                      }
                      alert("Selected holidays submitted successfully!");
                      await dispatch(
                        fetchHolidaysThunk({ user_id: userData.id })
                      );
                      setRecentHolidayId(lastInsertedId);
                      setHolidaySubTab("list");
                      setTimeout(() => {
                        dispatch(setStepIndex(5));
                      }, 0);
                    } catch (error) {
                      console.error("Bulk submit error:", error);
                      alert("Failed to submit one or more holidays.");
                    }
                  }}
                />
              </div>
            )}
            {holidaySubTab === "list" && (
              <GenericEventList
                itemType="holiday"
                title="Holiday"
                data={holidays}
                onEdit={(holiday) => {
                  setEditHoliday({
                    ...holiday,
                    start_date: moment(holiday.start_date).format("YYYY-MM-DD"),
                    end_date: moment(holiday.end_date).format("YYYY-MM-DD"),
                  });
                  setShowAddHolidayForm(true);
                  setHolidaySubTab("custom");
                }}
                onDelete={handleDeleteHoliday}
                showNumberOfDays={true}
              />
            )}
            {(holidaySubTab === "custom" || showAddHolidayForm) && (
              <AddCalendarEventForm
                onClose={() => {
                  dispatch(fetchHolidaysThunk({ user_id: userData.id })); // ✅ Pass user_id
                  setShowAddHolidayForm(false);
                  setEditHoliday(null);
                  setHolidaySubTab("list");
                }}
                itemType="holiday"
                editItem={editHoliday}
              />
            )}
          </div>
        );
      case "competitions":
        return (
          <div className="px-5 mx-5">
            {/* Sub-tab navigation for Competitions */}
            <div className="d-flex mb-3">
              <button
                className="btn btn-primary me-2"
                onClick={() => handleTabClick("calendar")}
              >
                Back
              </button>
              <button
                className={`btn me-2 ${competitionSubTab === "checkboxList"
                  ? "btn-primary"
                  : "btn-light"
                  }`}
                data-tour="competition-proposed-tab"
                onClick={() => {
                  setCompetitionSubTab("checkboxList");
                  dispatch(setStepIndex(1))
                }}

              >
                Proposed Competitions
              </button>
              <button
                className={`btn me-2 ${competitionSubTab === "fullList" ? "btn-primary" : "btn-light"
                  }`}
                data-tour="competition-list"
                onClick={() => {
                  setCompetitionSubTab("fullList");
                  setShowAddCompetitionForm(false);
                  setEditCompetition(null);
                }}
              >
                Competition List
              </button>
              {userData.roles !== "user" && (
                <button
                  className={`btn ${competitionSubTab === "addForm"
                    ? "btn-primary"
                    : "btn-light"
                    }`}
                  onClick={() => {
                    setCompetitionSubTab("addForm");
                    setShowAddCompetitionForm(true);
                    setEditCompetition(null);
                  }}
                >
                  Add New Competition
                </button>
              )}
            </div>
            {activeTab === "competitions" &&
              competitionSubTab === "checkboxList" && (
                <CompetitionCategoryTabs
                  userData={userData}
                  selected={selectedCompetitions}
                  setSelected={setSelectedCompetitions}
                  categories={groupedCompetitions}
                  onSelect={(comp) => {
                    setEditCompetition({
                      ...comp,
                      start_date: moment(comp.start_date).format("YYYY-MM-DD"),
                      end_date: moment(comp.end_date).format("YYYY-MM-DD"),
                    });
                    setShowAddCompetitionForm(true);
                    setCompetitionSubTab("custom");
                  }}
                  onBulkSubmit={async (selectedData) => {
                    try {
                      let lastInsertedId = null;

                      for (const comp of selectedData) {
                        console.log("selected competition data:", comp);
                        const payload = {
                          school_id: 1,
                          user_id: userData.id,
                          details: comp.name,
                          start_date: moment(comp.start_date).format(
                            "YYYY-MM-DD"
                          ),
                          end_date: moment(comp.end_date).format("YYYY-MM-DD"),
                          competition_cat_id: comp.competition_id,
                          status: "active",
                        };
                        const res = await dispatch(
                          createCompetitionThunk(payload)
                        ).unwrap();

                        lastInsertedId = res?.id;

                      }
                      alert("Submitted successfully!");
                      await dispatch(
                        fetchCompetitionsThunk({ user_id: userData.id })
                      );
                      setRecentCompetitionId(lastInsertedId);
                      setCompetitionSubTab("fullList");
                      setTimeout(() => {
                        dispatch(setStepIndex(5));
                      }, 0);
                    } catch (err) {
                      alert("Submission failed");
                    }
                  }}
                />
              )}
            {competitionSubTab === "fullList" && (
              <GenericEventList
                itemType="competition"
                title="Competition"
                data={competitions} // Displays actual active competitions
                onEdit={handleEditCompetition}
                onDelete={handleDeleteCompetition}
              />
            )}

            {competitionSubTab === "addForm" && (
              <AddCalendarEventForm
                onClose={() => {
                  dispatch(fetchCompetitionsThunk({ user_id: userData.id }));
                  setShowAddCompetitionForm(false);
                  setEditCompetition(null);
                  setCompetitionSubTab("fullList");
                }}
                itemType="competition"
                editItem={editCompetition}
              />
            )}
          </div>
        );
      case "exams":
        return (
          <div className="px-5 mx-5">
            {/* Sub-tab navigation for Exams */}
            <div className="d-flex mb-3">
              <button
                className="btn btn-primary me-2"
                onClick={() => handleTabClick("calendar")}
              >
                Back
              </button>
              {userData?.roles !== "user" && (
                <button
                  className={`btn me-2 ${examSubTab === "checkboxList" ? "btn-primary" : "btn-light"
                    }`}
                  data-tour="exam-select-tab"
                  onClick={() => {
                    setExamSubTab("checkboxList");
                    dispatch(setStepIndex(1));
                  }}
                >
                  Select Exams
                </button>
              )}
              <button
                className={`btn me-2 ${examSubTab === "fullList" ? "btn-primary" : "btn-light"
                  }`}
                data-tour='exam-list'
                onClick={() => {
                  setExamSubTab("fullList");
                  setShowAddExamForm(false);
                  setEditExam(null);
                }}
              >
                Exams List
              </button>
              {userData.roles !== "user" && (
                <button
                  className={`btn ${examSubTab === "addForm" ? "btn-primary" : "btn-light"
                    }`}
                  onClick={() => {
                    setExamSubTab("addForm");
                    setShowAddExamForm(true);
                    setEditExam(null);
                  }}
                >
                  Add Exam
                </button>
              )}
            </div>

            {examSubTab === "checkboxList" && (
              <ExamCategoryTabs
                onSubmitted={(id) => {
                  setRecentExamId(id);

                  // 🔥 FORCE TAB CHANGE FIRST
                  setExamSubTab("fullList");

                  // 🔥 ALLOW LIST TO RENDER
                  setTimeout(() => {
                    dispatch(fetchExamsThunk({ user_id: userData.id }));
                  }, 0);
                }}
              />

            )}

            {examSubTab === "fullList" && (
              <GenericEventList
                itemType="exam"
                title="Examination / Test"
                data={exams} // Displays actual active exams
                onEdit={handleEditExam}
                onDelete={handleDeleteExam}
              />
            )}

            {examSubTab === "addForm" && (
              <AddCalendarEventForm
                onClose={() => {
                  dispatch(fetchExamsThunk({ user_id: userData.id }));
                  setShowAddExamForm(false);
                  setEditExam(null);
                  setExamSubTab("fullList");
                }}
                itemType="exam"
                editItem={editExam}
              />
            )}
          </div>
        );
      case "ptms":
        return (
          <div className="mx-5 px-5">
            {showAddPtmForm ? (
              <AddCalendarEventForm
                onClose={({ goToCalendar } = {}) => {
                  setShowAddPtmForm(false);
                  setEditPtm(null);

                  if (goToCalendar) {
                    handleTabClick("calendar"); // ✅ YOU ALREADY HAVE THIS
                  }
                }}
                itemType="ptm"
                editItem={editPtm}
              />
            ) : (
              <>
                <div className="d-flex justify-content-start mb-3">
                  <button
                    className="btn btn-primary me-2"
                    onClick={() => handleTabClick("calendar")}
                  >
                    Back
                  </button>
                  {userData.roles !== "user" && (
                    <button
                      className="btn btn-primary"
                      data-tour="ptm-add-btn"
                      onClick={() => {
                        setShowAddPtmForm(true);
                        dispatch(setStepIndex(1));
                      }}
                    >
                      Add Parent-Teacher Meeting
                    </button>
                  )}
                </div>
                <div data-tour="ptm-list">
                  <GenericEventList
                    itemType="ptm"
                    title="Parent-Teacher Meeting"
                    data={ptms}
                    onEdit={handleEditPtm}
                    onDelete={handleDeletePtm}
                  />
                </div>
              </>

            )}
          </div>
        );
      case "workingDays":
        return (
          <TotalWorkingDaysReport
            onBackToCalendar={() => handleTabClick("calendar")}
          />
        );
      case "printCalendar":
        return (
          <PrintableAcademicCalendar
            onBackToCalendar={() => handleTabClick("calendar")}
          />
        );
      default:
        return (
          <CustomCalendar
            initialView="month"
            onSessionInfoUpdate={setSessionInfo}
          />
        );
    }
  };

  return (
    <div className="academic-calendar-container p-0">
      {/* Top Admin Controls Bar - Converted to Bootstrap Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark admin-controls-bar">
        <div className="container-fluid px-0 mx-0">

          {/* MOBILE NAVBAR - Only shows on mobile */}
          <MobileNavbar
            userData={userData}
            activeTab={activeTab}
            onTabClick={handleTabClick}
          />

          {/* DESKTOP MENU - Only shows on desktop (hidden on mobile) */}
          <div className="d-none d-lg-block" id="navbarNav">
            <ul className="navbar-nav admin-buttons-wrapper">
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "back" ? "active" : ""}`}
                  href="#"
                  onClick={(e) => { e.preventDefault(); navigate("/Dashboard"); }}
                >
                  <i className="fa fa-home"></i>
                  <span>Home</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "calendar" ? "active" : ""}`}
                  href="#"
                  onClick={(e) => { e.preventDefault(); handleTabClick("calendar"); }}
                >
                  <i className="fa fa-calendar"></i>
                  <span>Calendar</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "sessions" ? "active" : ""}`}
                  href="#"
                  onClick={(e) => { e.preventDefault(); handleTabClick("sessions"); }}
                >
                  <i className="fa fa-calendar-check-o"></i>
                  <span>Sessions</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "celebrations" ? "active" : ""}`}
                  href="#"
                  onClick={(e) => { e.preventDefault(); handleTabClick("celebrations"); }}
                >
                  <i className="fa fa-birthday-cake"></i>
                  <span>Celebrations</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "awareness" ? "active" : ""}`}
                  href="#"
                  onClick={(e) => { e.preventDefault(); handleTabClick("awareness"); }}
                >
                  <i className="fa fa-lightbulb-o"></i>
                  <span>Awareness</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "holidays" ? "active" : ""}`}
                  href="#"
                  onClick={(e) => { e.preventDefault(); handleTabClick("holidays"); }}
                >
                  <i className="fa fa-plane"></i>
                  <span>Holidays</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "competitions" ? "active" : ""}`}
                  href="#"
                  onClick={(e) => { e.preventDefault(); handleTabClick("competitions"); }}
                >
                  <i className="fa fa-trophy"></i>
                  <span>Competitions</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "exams" ? "active" : ""}`}
                  href="#"
                  onClick={(e) => { e.preventDefault(); handleTabClick("exams"); }}
                >
                  <i className="fa fa-pencil"></i>
                  <span>Exams</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "ptms" ? "active" : ""}`}
                  href="#"
                  onClick={(e) => { e.preventDefault(); handleTabClick("ptms"); }}
                >
                  <i className="fa fa-users"></i>
                  <span>PTM</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "workingDays" ? "active" : ""}`}
                  href="#"
                  onClick={(e) => { e.preventDefault(); handleTabClick("workingDays"); }}
                >
                  <i className="fa fa-calculator"></i>
                  <span>Working Days</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${activeTab === "printCalendar" ? "active" : ""}`}
                  href="#"
                  onClick={(e) => { e.preventDefault(); handleTabClick("printCalendar"); }}
                >
                  <i className="fa fa-print"></i>
                  <span>Print</span>
                </a>
              </li>
            </ul>
          </div>

          {/* DESKTOP PROFILE - Only shows on desktop */}
          <div className="d-none d-lg-flex align-items-center justify-content-end gap-3">
            <DemoContentButton moduleName="Academic Calendar" />
            <div className="dropdown me-3">
              <button
                className="btn btn-light dropdown-toggle d-flex align-items-center"
                type="button"
                id="userDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa fa-user me-2"></i>
                {userData.name}
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="userDropdown"
              >
                <li>
                  <span className="dropdown-item">Profile</span>
                </li>
                <li>
                  <Link to="/ai-integrate">
                    <span className="dropdown-item">Use AI</span>
                  </Link>
                </li>
                <li>
                  <span className="dropdown-item" onClick={logOut} style={{ cursor: "pointer" }}>
                    <i className="fa fa-sign-out me-2"></i>
                    Log Out
                  </span>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </nav>


      {/* Main Content Area: Calendar (Left) and Sidebar (Right) */}
      <div className="main-content-area   mx-5">
        {/* Left Section: Calendar View */}
        <div className="calendar-section">{renderContent()}</div>

        {/* Right Section: Sidebar */}
        {activeTab === "calendar" && (
          <div className="sidebar-section">
            {/* Event Categories */}
            <div className="sidebar-card event-categories-card border">
              <div className="card-header">Event Categories</div>
              <div className="card-content d-flex flex-column gap-2">
                {[
                  { color: "#D8BFD8", label: "Session Start" },
                  { color: "#4169E1", label: "Events & Celebrations" },
                  { color: "#FFFF00", label: "Holidays" },
                  { color: "#FFC0CB", label: "Competitions" },
                  { color: "#90EE90", label: "Examinations & Tests" },
                  { color: "#DDA0DD", label: "Parent Teacher Meetings" },
                  { color: "#8A2BE2", label: "Session End" },
                ].map((item, idx) => (
                  <div
                    key={idx}
                    className="legend-item d-flex align-items-center"
                  >
                    <span
                      className="color-box"
                      style={{
                        backgroundColor: item.color,
                        width: 14,
                        height: 14,
                        marginRight: 6,
                        borderRadius: 4,
                      }}
                    ></span>
                    <span>{item.label}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Upcoming Events */}
            <div className="sidebar-card upcoming-events-card border">
              <div className="card-header">Upcoming Events</div>
              <div className="card-content">
                {upcomingEvents.length > 0 ? (
                  upcomingEvents.map((event, idx) => (
                    <div key={idx} className="upcoming-event-item">
                      <span className="event-date">
                        {moment(
                          event.date || event.start_date,
                          "DD-MM-YYYY"
                        ).format("MMM D")}
                      </span>
                      <span className="event-title">
                        {event.name || event.details}
                      </span>
                    </div>
                  ))
                ) : (
                  <div className="no-events">No upcoming events.</div>
                )}
              </div>
            </div>

            {/* Session Information */}
            <div className="sidebar-card session-info-card border">
              <div className="card-header">Session Information</div>
              <div className="card-content">
                <div className="session-info-item">
                  <span className="info-label">Session Start</span>
                  <span className="info-value">{sessionInfo.sessionStart}</span>
                </div>
                <div className="session-info-item">
                  <span className="info-label">Session End</span>
                  <span className="info-value">{sessionInfo.sessionEnd}</span>
                </div>
                <div className="session-info-item">
                  <span className="info-label">Working Days</span>
                  <span className="info-value">
                    {sessionInfo.workingDays} days
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export function Button({ title, backgroundColor, onClick, className }) {
  const color = backgroundColor === "white" ? "black" : "white";
  return (
    <button
      type="button"
      className={`btn btn-primary ${className || ""}`}
      style={{
        backgroundColor,
        color,
        borderRadius: "10px",
        height: "34px",
        fontSize: "13px",
        padding: "0px 12px",
        outline: "none",
        boxShadow: "none",
        border: `1px solid ${backgroundColor === "white" ? "#ccc" : backgroundColor
          }`,
        flexShrink: 0, // Prevent buttons from shrinking
      }}
      onClick={onClick}
    >
      {title}
    </button>
  );
}

export default AcademicCalendar;